import { Price, Text } from "flicket-ui";

export interface IPriceWithFee {
  price: number;
  showFees: boolean;
  currency: string;
  isSoldOut?: boolean;
  fee?: number;
}

const PriceWithFee = ({
  price,
  currency,
  showFees = false,
  isSoldOut = false,
  fee = 0,
}: IPriceWithFee) => {
  if (isSoldOut) return <>Sold out</>;

  if (!price && !showFees) return <>Free</>;

  if (!price && fee <= 0) return <>Free</>;

  if (!showFees || fee <= 0) {
    return <Price price={price} currency={currency} />;
  }

  return (
    <>
      <Price price={price + fee} currency={currency} />{" "}
      <Text as="span" variant="small">
        (
        {price > 0 && (
          <>
            <Price price={price} currency={currency} /> +{" "}
          </>
        )}
        <Price price={fee} currency={currency} /> fees)
      </Text>
    </>
  );
};

export default PriceWithFee;
